
import { HttpClient } from './httpClient';
import store from '../store'
import _ from 'lodash';
import { intializeBrokerQryFunc, setLoadingState, unsetLoadingState, setRequestId } from '../actions/qryInputActions'
import { setRecentQry } from '../actions/recentQryActions';
import { toast } from '../../../commonComponents/Toast';
import {getMidRes, getImporterRes} from "../mocks";

/** Show fieldmessage on screen when API returns fieldmessagetype FAIL. Returns true if any FAIL was found. */
export const showFailFieldMessages = (res) => {
    const apiResponse = _.get(res, 'data.eventMessage.fieldmessage', []);
    if (!Array.isArray(apiResponse) || !apiResponse.length) {
        return false;
    }
    const failedResponses = apiResponse.filter(
        (resp) => resp && resp.fieldmessagetype === 'FAIL' && resp.fieldmessage
    );
    if (!failedResponses.length) {
        return false;
    }
    store.dispatch(unsetLoadingState());
    failedResponses.forEach((resp) => {
        toast.error(resp.fieldmessage);
    });
    return true;
};

export const displayMessageInsteadOfQryResponse = (messageObject) => {
    store.dispatch(unsetLoadingState());
    //console.log("displayMessageInsteadOfQryResponse  ===", resParam)
    let resParam = {
        "loading": false,
        mockResponseRequired: false,
        "qryInput": {
            "qryType":  "ES",  //  "BOL" / "ADCVD" / "CR"\
        },
        "qryOutput": {
            "outputType": "qryInput", // "qryInput", "recentQry", "",,
            executionTime: new Date(),
            "responseParams": messageObject
        }
    }
    store.dispatch(intializeBrokerQryFunc(resParam))
}

export const getQryResponseByRequestId = (requestid, action, qryType, counter, savingComplete, savingFailed) => {
    // Modal close/unmount sets qryTimeout — stop applying results / continue polling
    if (window.qryTimeout && counter) {
        store.dispatch(unsetLoadingState());
        return;
    }
    store.dispatch(setLoadingState());
    if (!counter) {
        window.qryTimeout = false;
    }
    let _qryType = action.qryType || qryType;
    let eventType = "";
    switch(_qryType) {
        case "ADCVD":
            eventType = "GET_ADCVD_QUERY_RESPONSE"
            break;
        case "BOL":
            eventType = "GET_BOL_QUERY_RESPONSE";
            //requestid = "NKFV3FGQBZGSNLXA5OJR";
            break;
        case "HTS":
            eventType = "GET_HTS_QUERY_RESPONSE";
            break;
        case "ES":
            eventType = "GET_MULTIPLE_ENTRY_SUMMARY_QUERY_RESPONSE";
            break;
        case "RESPONSE_SUMMARY":
            eventType = "GET_LATEST_RESPONSE_SUMMARY";
            break;
        case "CRITERIAQUERYQQ":
            eventType = "GET_MULTIPLE_ENTRY_SUMMARY_QUERY_RESPONSE";
            break;
        default:
            eventType = "GET_CBP_QUERY_RESPONSE";
            break;

    }
    const lowerEnv = (window.BASE_URL || "").match(/(staging|dev|stage|qat)/g);
    filerFunction(requestid, eventType, action.mot).then((response)=>{
        console.log("filerFunction", response);
        if (window.qryTimeout) {
            store.dispatch(unsetLoadingState());
            return;
        }
        if(_.isEmpty(response.data.eventMessage) || response.data.eventMessage.code == 404){
            store.dispatch(setRequestId({
                "requestid": requestid,
                "qryType":  _qryType,
                "searchParams": action.params
            }))


            if(response.data.eventMessage.code && response.data.eventMessage.code == 406){
                //let's load the error onto the ui as well, same as below
                let resParam = {
                    "loading": false,
                    mockResponseRequired: false,
                    "qryInput": {
                        "qryType":  action.qryType || qryType,  //  "BOL" / "ADCVD" / "CR"\
                        "requestid": requestid,
                        "searchParams": action.params
                    },
                    "qryOutput": {
                        "outputType": "qryInput", // "qryInput", "recentQry", "",,
                        executionTime: new Date(),
                        "responseParams": response.data.eventMessage
                    }
                }
                store.dispatch(intializeBrokerQryFunc(resParam))
            }

            if(response.data.eventMessage.code == 404 && lowerEnv){
                console.error("ALERT1 "+response.data.eventMessage.msg)
                store.dispatch(unsetLoadingState());
            }
            if(response.data.eventMessage.code == 404 && !window.qryTimeout && !lowerEnv){
                if(!counter){
                    counter = 1;
                }
                if(counter<30){
                    store.dispatch(setLoadingState());
                    window.qryResponseTimer && clearTimeout(window.qryResponseTimer);
                    window.qryResponseTimer = setTimeout(function(){
                        getQryResponseByRequestId(requestid, action, _qryType, counter);
                    }, 2000)

                    counter++;
                }else{
                    store.dispatch(unsetLoadingState());
                }
            }
        }else{
            //console.log("getQryResponseByRequestId else ===", resParam)
            if (window.qryTimeout) {
                store.dispatch(unsetLoadingState());
                return;
            }
            store.dispatch(unsetLoadingState());
            let resParam = {
                "loading": false,
                mockResponseRequired: false,
                "qryInput": {
                    "qryType":  action.qryType || qryType,  //  "BOL" / "ADCVD" / "CR"\
                    "requestid": requestid,
                    "searchParams": action.params
                },
                "qryOutput": {
                    "outputType": "qryInput", // "qryInput", "recentQry", "",
                    "responseParams": response.data.eventMessage,
                    executionTime: new Date(),

                }
            }
            store.dispatch(intializeBrokerQryFunc(resParam))
            let mid = _.get(response,"data.eventMessage.manufacturerDetails.mid", "");
            savingComplete && savingComplete(mid)
        }
    });
}

const newPromise = (_data) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({data: _data});
      }, 100);
    })
}

export const getQryByShipmentAndType = (shipId, docType, qryType, additionalDataParamtt, hts) => {
    // Job-status / non-modal tabs fetch existing query output. Constructor sets
    // qryTimeout=true on mount, which must not drop this response.
    window.qryTimeout = false;
    let originparameter = null;
    let myapi = "GET_CBP_QUERY_RESPONSES";

    let bolIdData = _.get(additionalDataParamtt,"bolIdData",{})
    console.log('bolIdData: ', bolIdData);
    let hbolnumber = bolIdData.bol || bolIdData.bolDocNumber;
    let mbolNumber = (bolIdData.modeOfTransport === "AIR" ?
        (bolIdData.masterBolNumber || "") :
        (bolIdData.bol || "")) || bolIdData.masterBolNumber;


    if(qryType == "CR"  && _.get(additionalDataParamtt,"bolIdData.nonModalWindow")){
        myapi = "GET_SHIPMENT_RELEASE_PGA_QUERY_RESPONSE";
    }
    if(qryType == "RESPONSE_SUMMARY"){
        myapi = "GET_LATEST_RESPONSE_SUMMARY";
        docType=null;
        originparameter = "query"

    }
    let mot = bolIdData.modeOfTransport || bolIdData.modeoftransport;
    let showHierarchy = mot != "AIR";

    let data = {
        "eventMessage": {
            houseBol:hbolnumber,
            masterBol:mbolNumber,
            "shipmentid":shipId,
            "shipmentId":shipId,
            showHierarchicalView: showHierarchy,
            "type": docType, //"DOC_CR_BOL_QUERY_REQUEST"
            "origin": originparameter,
        },
        "eventType": myapi,
        "eventTime": Date.now()
    }
    if (qryType == "ES" && additionalDataParamtt && additionalDataParamtt.bolIdData) {
        let entryNumber = additionalDataParamtt.bolIdData.entryNumber + "";

        data = {
            "eventMessage": {
                "entryNumber": entryNumber.substring(3, 99),
                "filerCode": entryNumber.substring(0, 3),
                // "entryNumber":"00000425",
                // "filerCode":"8AG"
            },
            "eventType": "GET_ENTRY_SUMMARY_QUERY_RESPONSE",
            "eventTime": Date.now()
        }
    }
    if (qryType == "BOL" && (hbolnumber || mbolNumber) && bolIdData.nonModalWindow) {
        if (bolIdData.modeOfTransport === "AIR") {//Obsolete this!
            data = {//Obsolete this!
                "eventMessage": {//Obsolete this!
                    shipmentId: shipId,//Obsolete this!
                    masterBol: mbolNumber,//Obsolete this!
                    houseBol: hbolnumber,//Obsolete this!
                },//Obsolete this!
                "eventType": "GET_SHIPMENT_BOL_ISF_QUERY_RESPONSE",//Obsolete this!
                "eventTime": Date.now()//Obsolete this!
            }//Obsolete this!
        } else {
            data = {
                "eventMessage": {
                    shipmentId: shipId,
                    shipmentid: shipId,
                    masterBol: mbolNumber,
                    houseBol: hbolnumber,
                    type: "DOC_CR_BOL_QUERY_REQUEST",
                    showHierarchicalView: true,
                },
                "eventType": "GET_CBP_QUERY_RESPONSES",
                "eventTime": Date.now()
            }
        }

    }
    if (qryType == "HTS" && hts){
        data = {
            "eventMessage": {
                shipmentId: shipId,
                hts: hts
            },
            "eventType": "GET_HTS_QUERY_RESPONSE",
            "eventTime": Date.now()
        }

    }
    return HttpClient.custom({
        data
    }).then((response)=>{
        let resParam = {
            "loading": false,
            "mockResponseRequired": false,
            "qryInput": {
                "qryType":  qryType,  //  "BOL" / "ADCVD" / "CR" / "HTS"
                "requestid": null,
                "searchParams": []
            },
            "qryOutput": {
                "outputType": "qryInput", // "qryInput", "recentQry", "",
                "executionTime": new Date(),
                "responseParams": response.data.eventMessage
            }
        }
        if(response.data.eventMessage && response.data.eventMessage.code === 404){
            alert("ALERT2 "+response.data.eventMessage.msg)
        }
        store.dispatch(intializeBrokerQryFunc(resParam))
        store.dispatch(unsetLoadingState());
    }).catch(function(res) {
        if(res instanceof Error) {
          console.log(res.message);
        } else {
          console.log(res.data);
        }
      });
}

export const fileBolQryFunction  = (brokerId, action) => {
    let bolNum = action.params.bolNumber;
    let mBol = action.params.mBolNumber;
    let wr1 = {
        "bolNumber": bolNum
    }
    if(action.mot === 'AIR'){
        wr1 = {
            "airWayBillNumber": mBol
        }
        if(bolNum && mBol!=bolNum){
            wr1["houseAirWayBillNumber"] = bolNum
        }
    }
    let data = {
        "eventMessage": {
            "wr1": wr1
        },
        "eventType": "FILE_CARGO_RELEASE_QUERY",
        "eventTime": Date.now()
    }
    if(brokerId){
        data.eventMessage.brokerId =  brokerId
    }
    if(action.shipmentId){
        data.eventMessage.shipmentId =  action.shipmentId
    }
    if(action.useKNCred){
        data.eventMessage.useKNCred = action.useKNCred
    }
    if(window.engineRequest == true){
        data.eventMessage.engineRequest = true
    }
    return HttpClient.custom({
        data
    }).then((res)=>{
        const hasFail = showFailFieldMessages(res);
        let responseData = _.get(res, "data.eventMessage.fieldmessage[1]");
        let requestid = responseData && ((responseData['field'] === "requestId") ? responseData['fieldmessage'] : null);
        if(requestid){
            if(window.brokerId){
                getRecentQry(window.brokerId);
            }
            getQryResponseByRequestId(requestid, action, action.qryType);
        } else if (hasFail) {
            return;
        }
    }).catch(function(res) {
        if(res instanceof Error) {
          console.log(res.message);
        } else {
          console.log(res.data);
        }
      });
}

export const fileCriteriaQryFunction = (brokerId, action) => {
    let paramObject= action.params;
    function datstrtobackendstr(datestr){//guaranteed to look like 2021-02-27
        let splitstr= datestr.split('-');
        return splitstr[1]+splitstr[2]+splitstr[0].substring(2,4)+"120000AM";
    }
    paramObject.fromDateTime = datstrtobackendstr(paramObject.fromDateTimeInput);
    paramObject.toDateTime = datstrtobackendstr(paramObject.toDateTimeInput);
    let data = {
        "eventMessage": {
            // "brokerId": brokerId,
            "shipmentId": action.shipmentId,
            "j2Record": paramObject,
        },
        "eventType": "FILE_CBP_ES_DATA_CRITERIA_QUERY",
        "eventTime": Date.now()
    }
    return HttpClient.custom({
        data
    }).then((res)=>{
        const hasFail = showFailFieldMessages(res);
        let responseData = _.get(res,"data.eventMessage['fieldmessage'][1]",null);
        let requestid = responseData && ((responseData['field'] == "requestId") ? responseData['fieldmessage'] : null);
        if(requestid){
            if(window.brokerId){
                getRecentQry(window.brokerId, action.page);
            }
            getQryResponseByRequestId(requestid, action, action.qryType);
        } else if (hasFail) {
            return;
        } else {//No data found
            displayMessageInsteadOfQryResponse(
                { "fieldmessage": "No data found",
                "fieldmessagetype": "FAIL" },
              )
            toast.error("No data found");


        }
    }).catch(function(res) {
        if(res instanceof Error) {
          console.log(res.message);
        } else {
          console.log(res.data);
        }
      });

}

export const fileCrQryFunction  = (brokerId, action) => {
    let isEngineView = window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN ===  'kxEngineBrokerToken';
    let data = {
        "eventMessage": {
            // "brokerId": isEngineView ? undefined : brokerId,
            "shipmentId": action.shipmentId || window.shipmentId || undefined,
            "wr1": {
                "entryNumber": action.params.entryNumber
            }
        },
        "eventType": "FILE_CARGO_RELEASE_QUERY",
        "eventTime": Date.now()
    }
    if(action.forReconciliation){
        data.eventMessage["shipmentId"] = action.shipmentId
        data.eventMessage["forReconciliation"] = true
    }
    if(window.engineRequest == true){
        data.eventMessage.engineRequest = true
    }
    return HttpClient.custom({
        data
    }).then((res)=>{
        const hasFail = showFailFieldMessages(res);
        let responseData = _.get(res, "data.eventMessage.fieldmessage[1]");
        let requestid = responseData && ((responseData['field'] == "requestId") ? responseData['fieldmessage'] : null);
        if(requestid){
            if(window.brokerId){
                getRecentQry(window.brokerId, action.page);
            }
            getQryResponseByRequestId(requestid, action, action.qryType);
        } else if (hasFail) {
            return;
        }
    }).catch(function(res) {
        if(res instanceof Error) {
          console.log(res.message);
        } else {
          console.log(res.data);
        }
      });
}
export const fileEsQryFunction  = (brokerId, action) => {
    const isDevEnvironment = window.BASE_URL.indexOf("dev-")>0 || window.BASE_URL.indexOf("-dev")>0;
    let isEngineView = window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN ===  'kxEngineBrokerToken';
    let j1recordsvar = {j1:[]};
    let indexx = 0;
    for(let oneentrySummary of action.params.entrySummaryInputList){
        if(!j1recordsvar.j1[Math.floor(indexx/5)])j1recordsvar.j1[Math.floor(indexx/5)]={};
        j1recordsvar.j1[Math.floor(indexx/5)][`entryNumber${(indexx%5+1)}`]=oneentrySummary.value;
        indexx++
    }
    let data = {
        "eventMessage": {
            "brokerId": isEngineView ? undefined : (brokerId || window.brokerId),
            "shipmentId": action.shipmentId || undefined,
            "j1Records": j1recordsvar
        },
        "eventType": "FILE_ENTRY_SUMMARY_QUERY",
        "eventTime": Date.now()
    }
    if(isDevEnvironment){
         data = {
            "eventMessage": {
                "brokerId": isEngineView ? undefined :  (brokerId || window.brokerId),
                "shipmentId": action.shipmentId || undefined,
                "j1Records": j1recordsvar
            },
            "eventType": "FILE_ENTRY_SUMMARY_QUERY",
            "eventTime": Date.now()
        }
    }
    if(action.forReconciliation){
        data.eventMessage["shipmentId"] = action.shipmentId
        data.eventMessage["forReconciliation"] = true
    }
    if(window.engineRequest == true){
        data.eventMessage.engineRequest = true
    }
    return HttpClient.custom({
        data
    }).then((res)=>{
        const hasFail = showFailFieldMessages(res);
        let responseData = _.get(res, "data.eventMessage.fieldmessage[1]");
        let requestid = responseData && ((responseData['field'] == "requestId") ? responseData['fieldmessage'] : null);
        if(requestid){
            if(window.brokerId){
                getRecentQry(window.brokerId, action.page);
            }
            getQryResponseByRequestId(requestid, action, action.qryType);
        } else {//No data found / FAIL without requestId
            const failMsg = (_.get(res, 'data.eventMessage.fieldmessage') || []).find(
                (resp) => resp && resp.fieldmessagetype === 'FAIL'
            );
            displayMessageInsteadOfQryResponse(failMsg || res.data.eventMessage['fieldmessage'][0])
            if (!hasFail) {
                const msg = _.get(failMsg || res.data.eventMessage['fieldmessage'][0], 'fieldmessage');
                if (msg) {
                    toast.error(msg);
                }
            }
        }
    }).catch(function(res) {
        if(res instanceof Error) {
          console.log(res.message);
        } else {
          console.log(res.data);
        }
      });
}
export const fileAdCvdQryFunction = (brokerId, action) => {
  let data = {
        "eventMessage": {
            "brokerId": brokerId,
            "q2": {
                "countryCode": action.params.countryCode,
                "htsNumber": action.params.htsNumber,
                "midCode": action.params.midCode
            }
        },
        "eventType": "FILE_ADCVD_QUERY",
        "eventTime": Date.now()
    }
    if(action.shipmentId){
        data.eventMessage.shipmentId = action.shipmentId;
      }
    if(window.engineRequest == true){
        data.eventMessage.engineRequest = true
    }
    return HttpClient.custom({
        data
    }).then((res)=>{
        const hasFail = showFailFieldMessages(res);
        let responseData = _.get(res, "data.eventMessage.fieldmessage[1]");
        let requestid = responseData && ((responseData['field'] == "requestId") ? responseData['fieldmessage'] : null);
        //let requestid = "WYLPFCOAXR5JCRZPXMR6";
        if(requestid){
            if(window.brokerId){
                getRecentQry(window.brokerId, action.page);
            }
            getQryResponseByRequestId(requestid, action, action.qryType);
        } else if (hasFail) {
            return;
        }
    }).catch(function(res) {
        if(res instanceof Error) {
          console.log(res.message);
        } else {
          console.log(res.data);
        }
      });
}

export const fileHtsQryFunction = (brokerId, action) => {
    let data = {
          "eventMessage": {
              "brokerId": brokerId,
              "w": {
                  "fromHtsNo": action.params.fromHtsNo,
                  "asOfDate": action.params.asOfDate
              }
          },
          "eventType": "FILE_HTS_QUERY",
          "eventTime": Date.now()
      }
      if(action.shipmentId){
        data.eventMessage.shipmentId = action.shipmentId;
      }
      if(action.params.toHtsNo){
        data.eventMessage.w.toHtsNo = action.params.toHtsNo
      }
      if(window.engineRequest == true){
        data.eventMessage.engineRequest = true
      }
      return HttpClient.custom({
          data
      }).then((res)=>{
          const hasFail = showFailFieldMessages(res);
          const apiResponse = _.get(res, 'data.eventMessage.fieldmessage', []);
          let responseData = apiResponse[1];
          let requestid = responseData && ((responseData['field'] === "requestId") ? responseData['fieldmessage'] : null);
          //let requestid = "WYLPFCOAXR5JCRZPXMR6";
          if(requestid){
              if(window.brokerId){
                getRecentQry(window.brokerId, action.page);
              }
              getQryResponseByRequestId(requestid, action, action.qryType);
          } else if (hasFail) {
              return;
          }
      }).catch(function(res) {
        if(res instanceof Error) {
          console.log(res.message);
        } else {
          console.log(res.data);
        }
      });
}

export const fileMidQryFunction = (brokerId, action) => {
    let data = {
          "eventMessage": {
              "record": {
                  "mid": action.params.mid
              }
          },
          "eventType": "FILE_MID_QUERY",
          "eventTime": Date.now()
      }
      if(brokerId){
        data.eventMessage.brokerId =  brokerId
      }
    if(action.shipmentId){
        data.eventMessage.shipmentId =  action.shipmentId
    }
      if(window.engineRequest == true){
        data.eventMessage.engineRequest = true
      }
      return HttpClient.custom({
          data
      }).then((res)=>{
          const hasFail = showFailFieldMessages(res);
          let responseData = _.get(res, "data.eventMessage.fieldmessage[1]");
          let requestid = responseData && ((responseData['field'] === "requestId") ? responseData['fieldmessage'] : null);
          //let requestid = "WYLPFCOAXR5JCRZPXMR6";
          if(requestid){
              if(window.brokerId){
                getRecentQry(window.brokerId, action.page);
              }
              getQryResponseByRequestId(requestid, action, action.qryType);
          } else if (hasFail) {
              return;
          }
      }).catch(function(res) {
        if(res instanceof Error) {
          console.log(res.message);
        } else {
          console.log(res.data);
        }
      });
}

export const fileImporterBondQryFunction = (brokerId, action) => {
    let data = {
          "eventMessage": {
              "brokerId": brokerId,
              "k": {
                  "importerNumber1": action.params.importerNumber1
              }
          },
          "eventType": "FILE_IMPORTER_BOND_QUERY",
          "eventTime": Date.now()
      }
      if(action.shipmentId){
        data.eventMessage.shipmentId = action.shipmentId;
      }
      if(window.engineRequest == true){
        data.eventMessage.engineRequest = true
      }
      return HttpClient.custom({
          data
      }).then((res)=>{
          const hasFail = showFailFieldMessages(res);
          let responseData = _.get(res, "data.eventMessage.fieldmessage[1]");
          let requestid = responseData && ((responseData['field'] == "requestId") ? responseData['fieldmessage'] : null);
          //let requestid = "WYLPFCOAXR5JCRZPXMR6";
          if(requestid){
              if(window.brokerId){
                getRecentQry(window.brokerId, action.page);
              }
              getQryResponseByRequestId(requestid, action, action.qryType);
          } else if (hasFail) {
              return;
          }
      }).catch(function(res) {
        if(res instanceof Error) {
          console.log(res.message);
        } else {
          console.log(res.data);
        }
      });
}

export const filerFunction = (reqId, eventType,mot) => {
    let data = {
        "eventMessage": {
            "requestid": reqId
        },
        "eventType": eventType,
        "eventTime": Date.now()
    }
    if(eventType == "GET_BOL_QUERY_RESPONSE" && !["AIR"].includes(mot)){
        data.eventMessage.showHierarchicalView= true;
        if(window.showRawDataFormatview){
            data.eventMessage.showHierarchicalView= false;
        }
    }
    //let res = getMidRes();
    //let res = getImporterRes();
    //return res;

    return HttpClient.custom({
        data
    })

}

//////
export const setManualResponse = (payload) => {
    let qryType = payload.payload.qryType;
    let docType = "";
    switch(qryType) {
        case 'BOL': {
            docType = "DOC_CARGO_RELEASE_QUERY_RESPONSE";
            break;
        }
        case 'ADCVD': {
            docType = "DOC_ADCVD_QUERY_RESPONSE";
            break;
        }
        case 'CR': {
            docType = "DOC_CARGO_RELEASE_QUERY_RESPONSE";
            break;
        }
        case 'IB': {
            docType = "DOC_IMPORTER_BOND_QUERY_RESPONSE";
            break;
        }
        case 'MID': {
            docType = window.docType ? window.docType : "DOC_MID_RESPONSE";
            break;
        }
        case 'ES': {
            docType = "DOC_ENTRY_SUMMARY_QUERY_RESPONSE";
            break;
        }
        case 'CRITERIAQUERYQQ': {
            docType = "DOC_ENTRY_SUMMARY_QUERY_RESPONSE";
            break;
        }
        case 'HTS': {
            docType = "DOC_HTS_QUERY_RESPONSE";
            break;
        }
        default :alert ("UNKNOWN QUERY TYPE "+qryType)
    }
    let data = {
        "eventMessage": {
            "doctype": docType,
            "requestid": payload.payload.requestid,
            "records": {
                "recordlist": payload.payload.recordList
            }
        },
        "eventType": "SET_RESPONSE_MANUAL",
        "eventTime": Date.now()
    }
    if(!payload.payload.recordList){
        delete data.eventMessage.records;
    }
    if(payload.payload.payload.extraParameterGeneric){
        data.eventMessage = {...data.eventMessage, ...payload.payload.payload.extraParameterGeneric}
    }
    return HttpClient.custom({
        data
    }).then((res)=>{
        let action = {
            "requestid": payload.payload.requestid,
            "qryType":  payload.payload.qryType,
            "searchParams": payload.payload.searchParams
        }
        getQryResponseByRequestId(payload.payload.requestid, action, payload.payload.qryType);
    }).catch(function(res) {
        if(res instanceof Error) {
          console.log(res.message);
        } else {
          console.log(res.data);
        }
      });
}

export const getRecentQry = (brokerId, page) => {
    let data = {
        "eventMessage": {
            "brokerId": brokerId,
            "page": page
        },
        "eventType": "SEARCH_BROKER_QUERIES",
        "eventTime": Date.now()
    }
    return HttpClient.custom({
        data
    }).then((res)=>{
        store.dispatch(setRecentQry(res))
    }).catch(function(res) {
        if(res instanceof Error) {
          console.log(res.message);
        } else {
          console.log(res.data);
        }
      });
}

export const saveDataToCbp = (mfData, brokerId, shipmentId, savingComplete, savingFailed) => {
    window.docType = "DOC_MID_ADD_RESPONSE";
    delete mfData.actorId;
    delete mfData["street "];
    let data = {
        "eventMessage": {
            md: mfData
        },
        "eventType":"SAVE_MID_CBP",
        "eventTime":Date.now()
      }
      if(shipmentId){
         data.eventMessage.shipmentId = shipmentId;
      } else if(brokerId){
        data.eventMessage.brokerId = brokerId;
      }
      return HttpClient.custom({
        data
      }).then((res)=>{
        if(_.get(res,"data.eventMessage.code") == 400){
            throw new Error(_.get(res,"data.eventMessage.msg", JSON.stringify(res.data.eventMessage)));

        }
        const hasFail = showFailFieldMessages(res);
        console.log('rddd7des: ', res);
        let responseData = _.get(res, "data.eventMessage.fieldmessage[1]");
        let requestid = responseData && ((responseData['field'] === "requestId") ? responseData['fieldmessage'] : null);

        let responseData4 = _.get(res, "data.eventMessage.fieldmessage[3]");
        let mid = (responseData4 && responseData4['field'] === "mid") ? responseData4['fieldmessage'] : null;
        if(requestid){
            // if(window.brokerId){
            //   getRecentQry(window.brokerId, action.page);
            // }
            let action = {
                "params": {
                    "mid": mid || mfData.mid
                },
                "qryType": "MID"
            }
            //savingComplete(mid)
            getQryResponseByRequestId(requestid, action, action.qryType, 0, savingComplete, savingFailed);
        } else if (!hasFail) {
            toast.error("Request-Id not generated..")
        }
    }).catch(function(res) {
      console.log('rdd9ddes: ', res);
      if(res instanceof Error) {
        console.log('rddddes: ',res.message);
        throw res;
      } else {
        console.log('rdddde1s: ',res.data);
      }
    });
}

export const getActorList = (keyword) => {
    let data = {
      "eventMessage":"1,"+keyword,
      "eventType":"GET_ACTOR_REF_ANY",
      "eventTime":Date.now()
    }
    return HttpClient.custom({
      data
    })
}

export const calculateMid = (payload) => {
    let newPayload = {
        "name": payload.name,
        "mid":"",
        "addressInfo": [{
            "type": "STREET_NUMBER",
            "information": _.get(payload, "address.STREET_NUMBER", "")
        }, {
            "type": "STREET_NAME",
            "information": _.get(payload, "address.STREET_NAME", "") ||  _.get(payload, "address.STREET", "")
        }, {
            "type": "CITY",
            "information": _.get(payload, "address.CITY", "")
        },  {
            "type": "POSTAL_CODE",
            "information": _.get(payload, "address.POSTAL_CODE", "")
        }, {
            "type": "COUNTRY",
            "information": _.get(payload, "address.COUNTRY", "")
        }]
    }
    
    if(["CA","CANADA"].includes(_.get(payload, "address.COUNTRY", "").toUpperCase()) &&  _.get(payload, "address.COUNTRY_SUB_ENTITY", "")){
        newPayload.addressInfo.push({
            "type": "COUNTRY_SUB_ENTITY",
            "information":  _.get(payload, "address.COUNTRY_SUB_ENTITY", "")
        });
    }
    let data = {
        "eventMessage": newPayload,
        "eventType":"CALCULATE_MID",
        "eventTime":Date.now()
      }
      return HttpClient.custom({
        data
      })
}

export const createActorRef = (mfData, updatedBy = "", savedInContextOf = "") => {
    let streetNum = "";
    let streetName = "";
    if(mfData.street){
        let street = mfData.street.trim().split(" ");
            streetNum = (street[0]).trim();
            streetName = street.slice(1).join(' ').trim();
    }
    let data = {
        "eventMessage": {
            "actorType": "1",
            "name": mfData.firmName,
            "countryCode": mfData.countryCode,
            "city": mfData.city,
            "state": mfData.state,
            "postalCode": mfData.zip,
            "streetNumber": streetNum,
            "streetName": " "+streetName.trimLeft(),
            "mid": mfData.mid,
            "unstructuredAddress": mfData.unstructuredAddress,
            "contactName": mfData.contactName,
            "actorEmail": mfData.contactEmail,
            "primaryPhone": mfData.contactPhone,
            "lastUpdatedBy": updatedBy,
            "savedInContextOf": savedInContextOf
        },
        "eventType": "CREATE_ACTOR_REF",
        "eventTime": Date.now()
    }
    return HttpClient.custom({
        data
    })
}

export const reconcileESFunction = (shipmentId, qryType, bolIdData) => {
    // store.dispatch(setLoadingState())
    let entryNumber = bolIdData.entryNumber + "";
    let data = {
        "eventMessage": {
            "entryNumber": entryNumber.substring(3, 99),
            "filerCode": entryNumber.substring(0, 3),
        },
        "eventType": "GET_ENTRY_SUMMARY_QUERY_RESPONSE",
        "eventTime": Date.now()
    }
    return HttpClient.custom({
        data
    }).then((res)=>{
        const {entrySummaryStatusCode, censusHeaderStatusMessage} = res.data.eventMessage
        const shipmentFormStatus = entrySummaryStatusCode === "Entry Summary accepted" && censusHeaderStatusMessage === "{}" ? "ACCEPTED" : "ACCEPTED_WITH_WARNING"
        let data = {
            "eventMessage": {
                "shipmentId": shipmentId,
                "shipmentFormType": "ENTRY_SUMMARY",
                "shipmentFormStatus": shipmentFormStatus
            },
            "eventType": "CONFIRM_SHIPMENT_RECONCILIATION",
            "eventTime": Date.now()
        }
        console.log("RECONCILE ES CALL", shipmentId, qryType)
        return HttpClient.custom({
            data
        }).then((res)=>{
            // store.dispatch(unsetLoadingState())
            alert("ALERT4 "+res.data.eventMessage.msg)
        }).catch(function(res) {
            if(res instanceof Error) {
            console.log(res.message);
            } else {
            console.log(res.data);
            }
        });
    }).catch(function(res) {
        if(res instanceof Error) {
          console.log(res.message);
        } else {
          console.log(res.data);
        }
    });
}

export const reconcileCRFunction = (shipmentId, qryType) => {
    // store.dispatch(setLoadingState())
    let data = {
        "eventMessage": {
            "shipmentId": shipmentId,
            "shipmentFormType": "CARGO_RELEASE",
            "shipmentFormStatus": "ACCEPTED"
        },
        "eventType": "CONFIRM_SHIPMENT_RECONCILIATION",
        "eventTime": Date.now()
    }
    console.log("RECONCILE CR CALL", shipmentId, qryType)
    return HttpClient.custom({
        data
    }).then((res)=>{
        // store.dispatch(unsetLoadingState())
        alert("ALERT5 "+res.data.eventMessage.msg)
    }).catch(function(res) {
        if(res instanceof Error) {
        console.log(res.message);
        } else {
        console.log(res.data);
        }
    });
}
